import {ICounterpartiesType, CounterpartiesTypeResponseType} from "@/entity/finance/counterparties/counterpartiesType.types";

export default class CounterpartiesType implements ICounterpartiesType {
    id: number;
    name: string;
    constructor(data: CounterpartiesTypeResponseType) {
        this.id = data.id;
        this.name = data.name;
    }
}